import $api from '../config/api'
import { tokenService } from './token'

export const forgotPassword = async (
  reqData: Pick<UserCredentials, 'email'>,
) => {
  const response = await $api.post('/auth/forgot-password', reqData)
  return response.data
}

export const resetPassword = async (reqData: {
  token: string
  password: string
  passwordConfirmation: string
}) => {
  const response = await $api.post('/auth/reset-password', reqData)
  return response.data
}

export const signIn = async (userData: Omit<UserCredentials, 'username'>) => {
  const { data } = await $api.post('/auth/signin', userData)
  tokenService.updateTokens(data.access_token)
  return data
}

export const registration = async (userData: UserCredentials) => {
  const { data } = await $api.post('/auth/signup', userData)
  tokenService.updateTokens(data.access_token)
  return data
}

export const validate = async (userData: UserIdentity) => {
  const { data } = await $api.post('/auth/validate', userData)
  return data
}

export const signOut = () => {
  tokenService.removeToken()
  return { message: 'User has been sign out' }
}
